import {useMutation, useQueryClient} from "@tanstack/react-query";
import {TRANSACTIONS_QUERY_KEY} from "@/pages/private/Transactions/useTransactions";
import {WALLET_QUERY_KEY} from "@/pages/private/Wallet/useWallet";
import type {WithdrawalPayload} from "./withdrawal.schema";
import {type WithdrawalResponse, withdrawalPagoMovilService} from "./withdrawal.service";

export const useWithdrawalPagoMovil = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<WithdrawalResponse, Error, WithdrawalPayload>({
    mutationFn: withdrawalPagoMovilService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: WALLET_QUERY_KEY});
      queryClient.invalidateQueries({queryKey: [TRANSACTIONS_QUERY_KEY]});
    },
  });

  return mutation;
};
